import { PayloadAction } from '../../../store.model';
import { Sort, SortOrder } from '../../grid';
import { INITIAL_MAX_ROWS } from '../fixture/initial-max-rows';
import { createNextGridState } from '../function/create-next-grid-state.function';
import { filterRows } from '../function/filter-rows.function';
import { sortRows } from '../function/sort-rows.function';
import { ActionType } from '../landing.action';
import { LandingState } from '../landing.state';

import { SortRows } from './sort-rows.action';

export function sortRowsReducer(
    state: LandingState,
    action: PayloadAction<ActionType.EVAL_LANDING__SORT_ROWS, SortRows>,
): LandingState {
    const nextState: LandingState = { ...state };

    try {
        const ngo = createNextGridState(action.payload.grid, state, nextState);

        const currentSortState: Sort = ngo.sortOptions ?? {
            columnId: null,
            order: null,
        };
        let nextSortOrder = action.payload.options?.order;
        if (currentSortState.columnId === action.payload.options?.columnId) {
            nextSortOrder =
                currentSortState.order === SortOrder.ASC
                    ? SortOrder.DESC
                    : SortOrder.ASC;
        }
        const nextSortOptions: Sort = {
            ...currentSortState,
            columnId: action.payload.options?.columnId,
            order: nextSortOrder,
        };
        let nextFilteredRows = filterRows(ngo.rows, ngo.selectedFilterOptions);
        nextFilteredRows = sortRows(nextFilteredRows, nextSortOptions);
        nextFilteredRows = nextFilteredRows.slice(
            0,
            ngo.showAll ? ngo.rows.length : INITIAL_MAX_ROWS,
        );

        ngo.filteredRows = nextFilteredRows;
        ngo.sortOptions = nextSortOptions;
    } catch {}

    return nextState;
}
